import {
  ConferenceIndexSchema,
  ConferenceCatalogSchema,
  ReaderAnalysisIndexSchema,
  TalkSchema,
  type ConferenceIndex,
  type ConferenceCatalog,
  type ReaderAnalysisIndex,
  type Talk,
} from './schema';

function dataRoot(conferenceId: string): string {
  return `/data/conference/${encodeURIComponent(conferenceId)}`;
}

async function loadJson(url: string): Promise<unknown> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Conference data request failed with status ${String(response.status)}.`,
    );
  }
  return response.json();
}

export async function loadConferenceCatalog(): Promise<ConferenceCatalog> {
  return ConferenceCatalogSchema.parse(
    await loadJson('/data/conference/index.json'),
  );
}

export async function loadConferenceIndex(
  conferenceId: string,
): Promise<ConferenceIndex> {
  return ConferenceIndexSchema.parse(
    await loadJson(`${dataRoot(conferenceId)}/talks/index.json`),
  );
}

export async function loadTalk(talkId: string, conferenceId: string): Promise<Talk> {
  const safeTalkId = encodeURIComponent(talkId);
  return TalkSchema.parse(
    await loadJson(`${dataRoot(conferenceId)}/talks/${safeTalkId}.json`),
  );
}

export async function loadReaderAnalysis(
  conferenceId: string,
): Promise<ReaderAnalysisIndex> {
  return ReaderAnalysisIndexSchema.parse(
    await loadJson(`${dataRoot(conferenceId)}/reader-analysis.json`),
  );
}
